;(function ($) {
  $.fn.reverse = function () {
    return $($(this).get().reverse())
  }
})(jQuery)
